import { ensureError } from "esa-core";
import type { JSX } from "react";
import Component, {
  CommonErrorPanelProps,
} from "components/ErrorPanel/CommonErrorPanel";
import { useLogUnexpectedError } from "hooks/useLogUnexpectedError";
import { useVersion } from "hooks/useVersion";

// ErrorBoundary は Error 以外の throw も渡してくるため、ここだけ広く受ける。
// ログには生値を送り、表示用の Error への変換はこのコンテナで閉じる
export type CommonErrorPanelContainerProps = Omit<
  CommonErrorPanelProps,
  "error"
> & {
  error: unknown;
};

const CommonErrorPanel = ({
  error,
  ...props
}: CommonErrorPanelContainerProps): JSX.Element => {
  const { refreshRequired } = useVersion();

  useLogUnexpectedError(error);

  return (
    <Component
      refreshRequired={refreshRequired}
      error={ensureError(error)}
      {...props}
    />
  );
};

export default CommonErrorPanel;
